import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { CommonService, SharedserviceService } from 'src/app/services';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DatePipe } from '@angular/common';
declare var $:any;

@Component({
  selector: 'app-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.scss'],
  providers:[DatePipe,NgxUiLoaderService]

})
export class AccountsComponent implements OnInit {
  date:any;
  ccData:any;
  compData:any;
  compDtl:any=[];
  sortedList: any[];
  list_data:any=[];
  old_credit_limit:any;
  // ngxLoader:any;
  detail_data:any;
  submitted:boolean=false;
  searchFlagReset:boolean=false;bodydata:any={};
  TotalCount:any;data:any;keys:any;public page: number = 1;start = 0;msg:any;status:any;FormId:any;flag:boolean=false;
  accountData:any;
  account:any;
  resltData:any=[];
  todaydate:any= this.datePipe.transform(new Date(), 'dd/MM/yyyy')
    public addaccountValue : FormGroup; 
    element:any;
  user_id: any=[];
  ownerData:any;
  count: any;
    constructor(
      private fb: FormBuilder, 
      public sharedService: SharedserviceService, 
      public router: Router,
      private datePipe: DatePipe,
      private toastr: ToastrManager,
      private activatedRoute:ActivatedRoute,
      public dataservice:CommonService,
      private ngxLoader: NgxUiLoaderService,
    ) { 
      this.sortedList=this.ccData;
      this.ownerData = localStorage.getItem("ownerData");
    }
  
    ngOnInit() {
        this.showList();
    }
  
 
    
    showList(){
      var self = this;
       self.sharedService.get('v1/bank/list').subscribe((res:any) =>{
        if (res.replyCode == "success") {
          this.list_data = res.data.rows;
          this.count = res.data.count
          console.log("data::::",this.list_data)
        }
       },err=> {
        this.toastr.errorToastr(err.error.replyMsg, "Error");
      })
      
    }
  
  
  }
  
  
  